import { render, staticRenderFns } from "./Labor_cost_statistics.vue?vue&type=template&id=303bb301"
import script from "./Labor_cost_statistics.vue?vue&type=script&lang=js"
export * from "./Labor_cost_statistics.vue?vue&type=script&lang=js"
import style0 from "./Labor_cost_statistics.vue?vue&type=style&index=0&id=303bb301&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports